type CommandArray = Array<(this: typeof globalThis) => void> | undefined;

declare global {
  interface Window {
    adngin?: {
      adnginLoaderReady?: boolean;
      cmd: {
        startAuction: (ads: string[]) => void;
      };
      queue?: CommandArray;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    adconsent: (
      arg0: string,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      arg1?: any,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      arg2?: (consent: any, success: any) => any,
    ) => void;
    destroyRefreshTopAd?: (state: boolean) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtag?: any;
    snigelPubConf: {
      adengine: {
        activeAdUnits: string[];
      };
    };
    __tcfapi: (
      arg0: string,
      arg1: number,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      arg2: (tcData: any, success: any) => void,
    ) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    googletag?: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dataLayer?: any[];
  }
}

/**
 * Check for consent through Snigel, then set GA consent
 */
export const checkForConsent = () => {
  window.addEventListener('adnginLoaderReady', function () {
    window.adconsent &&
      window.adconsent('getConsent', null, function (consent, success) {
        if (success) {
          if (consent.fullConsent) {
            console.log('########### yas consent');
            window.gtag('consent', 'update', {
              ad_storage: 'granted',
              analytics_storage: 'granted',
              ad_user_data: 'granted',
              ad_personalization: 'granted',
            });
          } else {
            console.log('########### naur consent');
            clearAnalyticsCookies();
          }
        }
      });
  });
};

const clearAnalyticsCookies = () => {
  const teuteufCookieNames = [
    '_gid',
    '_ttp',
    '_tt_enable_cookie',
    'ttcsid',
    'ttcsid_D08JD33C77U9CBHGPDHG',
  ];
  const tiktokCookieNames = ['_ttp'];

  // delete all _ga cookies
  document.cookie
    .split(';')
    .map((c) => c.trim())
    .forEach((cookie) => {
      const name = cookie.split('=')[0];
      if (name.startsWith('_ga')) {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.flagle.io`;
      }
    });

  // delete other analytics cookies
  teuteufCookieNames.forEach((name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.flagle.io`;
  });
  tiktokCookieNames.forEach((name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.tiktok.com;`;
  });
};

/**
 * Loads ad script and sets active ad units.
 * For Premium users ad script needs to be loaded so we can get consent, but active units should be empty so no ads appear.
 * For non premium users, ad script needs to be loaded with correct active ad units.
 */
export function loadAdScript(isPremium: boolean) {
  // set active ad units
  setActiveAdUnits(isPremium);

  const href = window.location.href;

  let src = '';
  if (href.includes('staging') || href.includes('localhost')) {
    src = 'https://staging-cdn.snigelweb.com/adengine/flagle.io/loader.js';
  } else {
    src = 'https://cdn.snigelweb.com/adengine/flagle.io/loader.js';
  }

  const scriptTag = document.createElement('script');
  scriptTag.src = src;
  scriptTag.id = 'snigel';
  scriptTag.async = true;
  scriptTag.setAttribute('data-cfasync', 'false');
  scriptTag.type = 'text/javascript';

  scriptTag.addEventListener('load', () => {
    let breakpoint = 'xsmall';
    const w = window.innerWidth;

    breakpoint = w >= 768 ? 'small' : breakpoint;
    breakpoint = w >= 960 ? 'medium' : breakpoint;
    breakpoint = w >= 1280 ? 'large' : breakpoint;
    breakpoint = w >= 1400 ? 'xlarge' : breakpoint;

    /* eslint-disable @typescript-eslint/no-explicit-any */
    const googletag = (window as any).googletag;
    googletag.cmd.push(() => {
      googletag.pubads().set('page_url', 'flagle.io');
      googletag
        .pubads()
        .addEventListener('slotRenderEnded', function (event: any) {
          const slot_id = event.slot.getSlotElementId();
          if (slot_id === 'adngin-top_banner-0') {
            document.documentElement.classList.add('snigel-top-loaded');
            document.documentElement.classList.add(
              'snigel-' + breakpoint.toLowerCase(),
            );
          }
        });
    });
  });
  document.getElementsByTagName('head')[0].appendChild(scriptTag);
}

export function destroyTopAd(state: boolean) {
  if (typeof window.destroyRefreshTopAd === 'function') {
    try {
      window.destroyRefreshTopAd(state);
    } catch (e) {
      console.error(e);
    }
  }
}

export function refreshAd() {
  setTimeout(() => {
    if (
      window.adngin !== undefined &&
      window.adngin.cmd !== undefined &&
      typeof window.adngin.cmd.startAuction === 'function'
    ) {
      window.adngin.cmd.startAuction(['sidebar_right']);
    }
  }, 50);
}

export function refreshTopAd(state: boolean) {
  if (!state) return;
  if (
    window.adngin !== undefined &&
    window.adngin.cmd !== undefined &&
    window.adngin.adnginLoaderReady &&
    typeof window.adngin.cmd.startAuction === 'function'
  ) {
    window.adngin.cmd.startAuction(['top_banner']);
  }
}

export function refreshCompleteAd() {
  console.log('refresh 300x250 ad');
  if (
    window.adngin !== undefined &&
    window.adngin.cmd !== undefined &&
    typeof window.adngin.cmd.startAuction === 'function'
  ) {
    window.adngin.cmd.startAuction(['end_mobile']);
  }
}

function setActiveAdUnits(isPremium: boolean): void {
  if (isPremium) {
    window.snigelPubConf = {
      adengine: {
        activeAdUnits: [''],
      },
    };
    return;
  }
  const activeUnits = getActiveAdUnits();
  window.snigelPubConf = {
    adengine: {
      activeAdUnits: activeUnits,
    },
  };
}

function getActiveAdUnits(): string[] {
  let breakpoint = 'xsmall';

  const w = window.innerWidth;
  const h = window.innerHeight;

  breakpoint = w >= 768 ? 'small' : breakpoint;
  breakpoint = w >= 960 ? 'medium' : breakpoint;
  breakpoint = w >= 1280 ? 'large' : breakpoint;
  breakpoint = w >= 1400 ? 'xlarge' : breakpoint;

  let units = [];

  switch (breakpoint.toLowerCase()) {
    case 'xsmall': // Small Mobile
    case 'small': // Portrait Tablet / Large Mobile
      units = ['top_banner']; // Mobile Ad Units
      if (h > 560) {
        units.push('incontent');
      }
      break;
    default:
    case 'medium':
    case 'xlarge':
    case 'large':
      units = ['sidebar_left', 'sidebar_left_bottom', 'video'];
      break;
  }

  return units;
}

export async function detectAdBlocker(): Promise<boolean> {
  // Look at git history if we want to re-instate
  return false;
}
